/**
 * 门户边框默认配置数据
 */
export const home = [{}]

/**
 * 大屏边框默认配置数据
 */
const bgImgs = [
  require("assets/images/leftMenu/border/border1.png"),
  require("assets/images/leftMenu/border/border2.png"),
  require("assets/images/leftMenu/border/border3.png"),
  require("assets/images/leftMenu/border/border4.png"),
  require("assets/images/leftMenu/border/border5.png"),
  require("assets/images/leftMenu/border/border6.png")
]
export const bs = [
  { imgSrc: bgImgs[0] },
  { imgSrc: bgImgs[1], styleId: 2 },
  { imgSrc: bgImgs[2], styleId: 3 },
  { imgSrc: bgImgs[3], styleId: 4 },
  { imgSrc: bgImgs[4], styleId: 5 },
  { imgSrc: bgImgs[5], styleId: 6 }
]

/**
 * app边框默认配置数据
 */
export const appHome = [{}]
